import yup from '~/utils/validation';

export const reportFormSchema = yup.object().shape({
    report: yup.string().required(),
});
